import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import MultiColumnLayout from '../../Shared/MultiColumnLayout';
import Link from '../../../Core/Link';
import { Category, ArticleTitle, Info, Date, Author } from '../styles';
import { getDate } from '../../../../utils';

import {
  Wrapper,
  StyledContainer,
  Card,
  StyledImage,
  Content,
  StyledCopy,
  OptionalImg,
} from './styles';

// TODO Create a new style in the blogCards and use the new style here, instead of slightly altering style files

/*
 * This is the section of curated posts on the blog page
 * popularPostsTitle: {string} the main title for the section
 * headingData.image: {object} the object that holds all the data for the featured image, url, alt, etc
 * titleShort: {string} shortened version of the title to be displayed in the blog card
 * category: {string} the type of the category for the blog
 * publishDate: {string} the date the blog was published, in yyyy-mm-dd format. This is passed to the getDate func to return the date in the format to display to the user
 * author: {string} the name of the author that wrote the blog post
 * metaDescription: {string} the body copy that is written to specifically display in the blog card
 * url: {string} the path that the article page is created under
 */

const PopularPosts = ({ data }) => {
  if (!data) return null;
  const { primary, items } = data;
  // * Check to see if the optional image at the bottom is present. Style section accordingly
  const hasOptionalImage = primary[0].image ? 'with-image' : '';
  return (
    <Wrapper>
      <StyledContainer className={['auto-margin', hasOptionalImage]}>
        {ReactHtmlParser(primary[0].titleHtml)}
        <MultiColumnLayout spacing="15px">
          {items.map(({ article }, index) => {
            if (!article) return null;
            const {
              url,
              author,
              publishDate,
              category,
              titleShort,
              headingData,
            } = article;
            return (
              <Link to={`/blog/${url}`} className="unstyled blog-post" noSpan>
                <Card key={`${url}-${author.name}-${index.toString()}`}>
                  {headingData.imageExpanded &&
                    headingData.imageExpanded.imageCard && (
                      <StyledImage
                        src={headingData.imageExpanded.imageCardSharp}
                        alt={headingData.imageExpanded.imageCard.altTag}
                        objectFit="cover"
                      />
                    )}
                  <Content>
                    <Category>
                      {category.map(({ id, text }, categoryIndex) => {
                        return (
                          <span key={id}>
                            {categoryIndex + 1 === category.length
                              ? `${text}`
                              : `${text}, `}
                          </span>
                        );
                      })}
                    </Category>
                    <ArticleTitle className="h4">{titleShort}</ArticleTitle>
                    <Info>
                      <Date>{getDate(publishDate)}</Date>
                      {author.map(({ name }, nameIdx) => (
                        <Author key={`${name[0].text}-${nameIdx.toString()}`}>
                          {name[0].text}
                        </Author>
                      ))}
                    </Info>
                    <StyledCopy className="small 5-line">
                      {ReactHtmlParser(headingData.teaserTextShortHtml)}
                    </StyledCopy>
                    <Link to={`/blog/${url}`}>Read more</Link>
                  </Content>
                </Card>
              </Link>
            );
          })}
        </MultiColumnLayout>
        {primary[0].imageSharp ? (
          <OptionalImg
            src={primary[0].imageSharp.publicURL}
            alt={primary[0].image.altTag}
          />
        ) : null}
      </StyledContainer>
    </Wrapper>
  );
};

PopularPosts.propTypes = {
  data: PropTypes.shape(),
};

PopularPosts.defaultProps = {
  data: null,
};

PopularPosts.defaultProps = {};

export default PopularPosts;
